module.exports = __webpack_public_path__ + "img/truncus-vault.1bac628b.png";